// Edit: look through populated players objects intead of document ids
async function roomHasAI(room) {
  for (let i = 0; i < room.teams.length; i++) {
    for (const player of room.teams[i].players) {
      let newPlayerDocument = await User.findOne({ _id: player })
      if (newPlayerDocument.type === 'ai') {
        return true
      }
    }
  }
  return false
}

export function firstAvailableTokenId({ pieces }) {
  for (const piece of pieces) {
    if (piece.tile === -1) {
      return piece.id
    }
  }
}

// returns an array with elements of tile indexes
export function getOccupiedTiles({ pieces }) {
  let occupiedTiles = new Set()
  for (const piece of pieces) {
    if (piece.tile !== 29) {
      occupiedTiles.add(piece.tile)
    }
  }
  let occupiedTilesArray = Array.from(occupiedTiles)
  return occupiedTilesArray
}